import React from 'react';
import {
	Lens,
	IcoPlus,
	TooltipInfoIcon,
	IcoInvestimentoBox,
	IcoPilBox,
	IcoFatturatoBox,
	IcoImposteBox,
	IcoRedditiBox,
	IcoOccupazioneBox,
	IcoMondoBox,
	IcoUtenteBox,
	IcoListBox,
	IcoCircleBox,
	IcoScenari,
	IcoScenario,
	IcoSetup,
	IcoGeneral,
	IcoTechnical,
	IcoEconomic,
	IcoAdditional,
	IcoAnalisys,
	IcoAnalisysBox,
	IcoDashboard,
	IcoMonitoring,
	IcoKpiStandard,
	ArrowDownUp,
	ArrowUp,
	ArrowDown,
	MaxMinimize,
	IcoLens,
	IcoCanc,
	IcoEdit,
	IcoBookBox,
	CloudArrowDown,
	Link,
	IcoCantiere,
	IcoFatturato,
	IcoEnterprise,
	IcoTax,
	IcoHome,
	IcoBag,
	IcoHeart,
	IcoDanger,
	IcoSuccess,
	IcoWarning,
	IcoInfo,
	ArrowsMeeting,
	Handshake,
	SocialNetworking,
	Sustainable,
	Environment,
	Logout,
	Eye,
	EyeSlash,
	UsersGear,
	User,
	IcoDownloadFile,
	IcoUploadFile,
	Print,
	IcoMinusCircled,
	IcoSummary,
	IcoMegaphone,
	IcoInstitution,
	IcoCandidacy,
	IcoAgenda,
	IcoReporting,
	IcoGear,
	IcoCheck,
	IcoCheckFailed,
	IcoReported,
	IcoReportedPartially,
	ExcelIcon,
	IcoHexagon,
	IcoCoins,
	IcoInfoSerif,
	IcoTiming,
	IcoExclamationPoint,
	IcoAi,
	IcoTimeForward,
	ChevronRightSolid,
	IcoLink,
	IcoSendMail,
	IcoNovuAllNotifications,
	IcoNovuUnreadNotifications,
	ArrowRight,
	ArrowLeft,
	ConfirmSolid,
	RejectSolid,
	ArrowDownDark,
	PlusWhite,
	ExclamationBrown,
	PersonCircle,
	// IcoUserCircle,
	IcoDownloadCloudArrow,
	IcoCross,
	ExclamationRed,
	IcoUnion,
	IcoFilterSquare,
	CircleGrey,
	BlackPause,
	HomeSolid,
	InfoCircleFill,
	ConfigureTemplate,
	ExportTemplate,
	FileTemplateExport,
	IcoDownloadCloudArrowSmall,
	IcoArrowClockwise,
	IcoUploadDocument,
	IcoEmptyCalendar,
	IcoNewAnalysis,
	IcoFolder,
	IcoInfoGrey,
	IcoEllipsis,
	IcoEditBox,
	Trash,
	IcoSquareFilter,
	IcoConformeDaValidare,
	IcoConformeValidato,
	IcoIncompleta,
	IcoBook,
	IcoExtendSampling,
	IcoEye,
	IcoEyeSlash,
	IcoAggregate,
	IcoClose,
	IcoPadlockOpen,
	IcoPadlockClosed,
	IcoPaper,
	IcoPapers,
	IcoFileGraph,
	IcoFileBreak,
	IcoConfirmCheck,
	IcoInfoOutline,
} from '@icons';
import {
	Ico3,
	Ico8,
	Ico19,
	Ico21,
	Ico29,
	Ico33,
	Ico35,
	Ico36,
	Ico42,
	Ico44,
	Ico45,
	Ico47,
	Ico89,
	Ico90,
	Ico91,
	Ico92,
	Ico93,
	Ico94,
	Ico95,
	Ico96,
	Ico97,
	Ico98,
	Ico99,
	Ico100,
	Ico101,
} from '@icons/new';

const Icone = () => {
	return (
		<div id="icons-page">
			<Lens title="Lens" />
			<IcoPlus title="IcoPlus" />
			<TooltipInfoIcon title="TooltipInfoIcon" />
			<IcoInvestimentoBox title="IcoInvestimentoBox" />
			<IcoPilBox title="IcoPilBox" />
			<IcoFatturatoBox title="IcoFatturatoBox" />
			<IcoImposteBox title="IcoImposteBox" />
			<IcoRedditiBox title="IcoRedditiBox" />
			<IcoOccupazioneBox title="IcoOccupazioneBox" />
			<IcoMondoBox title="IcoMondoBox" />
			<IcoUtenteBox title="IcoUtenteBox" />
			<IcoListBox title="IcoListBox" />
			<IcoCircleBox title="IcoCircleBox" />
			<IcoScenari title="IcoScenari" />
			<IcoScenario title="IcoScenario" />
			<IcoSetup title="IcoSetup" />
			<IcoGeneral title="IcoGeneral" />
			<IcoTechnical title="IcoTechnical" />
			<IcoEconomic title="IcoEconomic" />
			<IcoAdditional title="IcoAdditional" />
			<IcoAnalisys title="IcoAnalisys" />
			<IcoAnalisysBox title="IcoAnalisysBox" />
			<IcoDashboard title="IcoDashboard" />
			<IcoMonitoring title="IcoMonitoring" />
			<IcoKpiStandard title="IcoKpiStandard" />
			<ArrowDownUp title="ArrowDownUp" />
			<ArrowUp title="ArrowUp" />
			<ArrowDown title="ArrowDown" />
			<MaxMinimize title="MaxMinimize" />
			<IcoLens title="IcoLens" />
			<IcoCanc title="IcoCanc" />
			<IcoEdit title="IcoEdit" />
			<IcoBookBox title="IcoBookBox" />
			<CloudArrowDown title="CloudArrowDown" />
			<Link title="Link" />
			<IcoCantiere title="IcoCantiere" />
			<IcoFatturato title="IcoFatturato" />
			<IcoEnterprise title="IcoEnterprise" />
			<IcoTax title="IcoTax" />
			<IcoHome title="IcoHome" />
			<IcoBag title="IcoBag" />
			<IcoHeart title="IcoHeart" />
			<IcoDanger title="IcoDanger" />
			<IcoSuccess title="IcoSuccess" />
			<IcoWarning title="IcoWarning" />
			<IcoInfo title="IcoInfo" />
			<IcoInfoGrey title="IcoInfoGrey" />
			<ArrowsMeeting title="ArrowsMeeting" />
			<Handshake title="Handshake" />
			<SocialNetworking title="SocialNetworking" />
			<Sustainable title="Sustainable" />
			<Environment title="Environment" />
			<Logout title="Logout" />
			<Eye title="Eye" />
			<EyeSlash title="EyeSlash" />
			<UsersGear title="UsersGear" />
			<User title="User" style={{ fill: 'black' }} />
			<IcoDownloadFile title="IcoDownloadFile" />
			<IcoUploadFile title="IcoUploadFile" />
			<Print title="Print" />
			<IcoMinusCircled title="IcoMinusCircled" />
			<IcoSummary title="IcoSummary" style={{ fill: 'black' }} />
			<Ico3 title="Ico3" />
			<Ico8 title="Ico8" />
			<Ico19 title="Ico19" />
			<Ico21 title="Ico21" />
			<Ico29 title="Ico29" />
			<Ico33 title="Ico33" />
			<Ico35 title="Ico35" />
			<Ico36 title="Ico36" />
			<Ico42 title="Ico42" />
			<Ico44 title="Ico44" />
			<Ico45 title="Ico45" />
			<Ico47 title="Ico47" />
			<Ico89 title="Ico89" />
			<Ico90 title="Ico90" />
			<Ico91 title="Ico91" />
			<Ico92 title="Ico92" />
			<Ico93 title="Ico93" />
			<Ico94 title="Ico94" />
			<Ico95 title="Ico95" />
			<Ico96 title="Ico96" />
			<Ico97 title="Ico97" />
			<Ico98 title="Ico98" />
			<Ico99 title="Ico99" />
			<Ico100 title="Ico100" />
			<Ico101 title="Ico101" />
			<IcoInstitution title="IcoInstitution" />
			<IcoMegaphone title="IcoMegaphone" />
			<IcoCandidacy title="IcoCandidacy" />
			<IcoAgenda title="IcoAgenda" />
			<IcoReporting title="IcoReporting" />
			<IcoGear title="IcoGear" style={{ fill: 'black' }} />
			<IcoCheck title="IcoCheck" />
			<IcoCheckFailed title="IcoCheckFailed" />
			<IcoTimeForward title="IcoTimeForward" />
			<IcoReported title="IcoReported" />
			<IcoReportedPartially title="IcoReportedPartially" />
			<ExcelIcon title="ExcelIcon" style={{ fill: 'black' }} />
			<IcoHexagon title="IcoHexagon" style={{ fill: 'black' }} />
			<IcoCoins title="IcoCoins" />
			<IcoInfoSerif title="IcoInfoSerif" />
			<IcoTiming title="IcoTiming" />
			<IcoExclamationPoint title="IcoExclamationPoint" />
			<IcoAi title="IcoAi" style={{ fill: 'black' }} />
			<ChevronRightSolid title="ChevronRightSolid" />
			<IcoLink title="IcoLink" />
			<IcoSendMail title="IcoSendMail" />

			<IcoNovuAllNotifications title="IcoNovuAllNotifications" />
			<IcoNovuUnreadNotifications title="IcoNovuUnreadNotifications" />

			<ArrowRight title="ArrowRight" style={{ fill: 'black' }} />
			<ArrowDownDark
				title="ArrowDownDark"
				style={{
					fill: '#000',
				}}
			/>
			<ArrowLeft title="ArrowLeft" style={{ fill: 'black' }} />
			<ConfirmSolid title="ConfirmSolid" />
			<RejectSolid title="RejectSolid" />
			<PlusWhite title="PlusWhite" style={{ backgroundColor: 'lightgrey' }} />
			<ExclamationBrown title="ExclamationBrown" fill="#995C00" />
			<PersonCircle title="PersonCircle" fill="#000" />
			{/* <IcoUserCircle title="IcoUserCircle" /> */}
			<IcoDownloadCloudArrow title="IcoDownloadCloudArrow" />
			<IcoCross title="IcoCross" style={{ fill: 'black' }} />
			<ExclamationRed title="ExclamationRed" />
			<IcoUnion title="IcoUnion" />
			<IcoFilterSquare title="IcoFilterSquare" />
			<CircleGrey title="CircleGrey" />
			<BlackPause title="BlackPause" style={{ fill: 'black' }} />
			<HomeSolid title="HomeSolid" />
			<InfoCircleFill title="InfoCircleFill" style={{ fill: 'black' }} />

			<ConfigureTemplate title="ConfigureTemplate" />
			<ExportTemplate title="ExportTemplate" style={{ fill: 'black' }} />

			<FileTemplateExport title="FileTemplateExport" style={{ fill: 'black' }} />
			<IcoDownloadCloudArrowSmall title="IcoDownloadCloudArrowSmall" style={{ fill: 'black' }} />

			<IcoArrowClockwise title="IcoArrowClockwise" style={{ fill: 'black' }} />

			<IcoUploadDocument title="IcoUploadDocument" style={{ fill: 'black' }} />
			<IcoEmptyCalendar title="IcoEmptyCalendar" />
			<IcoNewAnalysis title="IcoNewAnalysis" />
			<IcoFolder title="IcoFolder" />
			<IcoInfoGrey title="IcoInfoGrey" />
			<IcoEllipsis title="IcoEllipsis" />
			<IcoEditBox title="IcoEditBox" />
			<Trash title="Trash" fill="#000" />

			<IcoSquareFilter title="IcoSquareFilter" fill="#000" />

			<IcoConformeDaValidare title="IcoConformeDaValidare" />
			<IcoConformeValidato title="IcoConformeValidato" />
			<IcoIncompleta title="IcoIncompleta" />

			<IcoBook title="IcoBook" fill="#000" />
			<IcoExtendSampling title="IcoExtendSampling" fill="#000" />

			<IcoEye title="IcoEye" fill="#000" />
			<IcoEyeSlash title="IcoEyeSlash" fill="#000" />
			<IcoAggregate title="IcoAggregate" fill="#000" />
			<IcoClose title="IcoClose" fill="#000" />
			<IcoPadlockOpen title="IcoPadlockOpen" fill="#000" />
			<IcoPadlockClosed title="IcoPadlockClosed" fill="#000" />
			<IcoPaper title="IcoPaper" fill="#000" />
			<IcoPapers title="IcoPapers" fill="#000" />
			<IcoFileGraph title="IcoFileGraph" fill="#000" />
			<IcoFileBreak title="IcoFileBreak" fill="#000" />

			<IcoConfirmCheck title="IcoConfirmCheck" fill="#000" />
			<IcoInfoOutline title="IcoInfoOutline" fill="#000" />
		</div>
	);
};

export default Icone;
